module.exports = __webpack_public_path__ + "static/media/screenshot_step1_4_purple.43349e32.svg";